import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GoogleReviewCard, GoogleReviewDialog } from "@/components/home/GoogleReviews";
import { ReviewForm, ReviewItem, Stars } from "@/components/home/ReviewForm";

export const Reviews = () => {
  const [data, setData] = useState({ reviews: [], count: 0, average: 0 });
  const [googleOpen, setGoogleOpen] = useState(false);

  const load = useCallback(() => {
    api.get("/reviews").then(({ data }) => setData(data)).catch((err) => console.warn("No se pudieron cargar las reseñas", err?.message));
  }, []);

  useEffect(() => { load(); }, [load]);

  const onPublished = () => {
    setGoogleOpen(true);
    load();
  };

  return (
    <section id="resenas" className="py-16 sm:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8 sm:mb-12">
          <div>
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900">Opiniones de nuestros clientes</h2>
            <p className="mt-3 text-slate-600">Tu opinión nos ayuda a mejorar cada día.</p>
          </div>
          {data.count > 0 && (
            <div className="flex items-center gap-3 bg-white border border-slate-200 rounded-full px-5 py-2.5" data-testid="reviews-average">
              <span className="font-heading font-bold text-2xl text-slate-900">{data.average.toFixed(1)}</span>
              <Stars value={Math.round(data.average)} size="h-5 w-5" />
              <span className="text-sm text-slate-500">({data.count})</span>
            </div>
          )}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          <ReviewForm onPublished={onPublished} />
          <div className="lg:col-span-7 space-y-4" data-testid="reviews-list">
            <GoogleReviewCard />
            {data.reviews.length === 0 && (
              <p className="text-slate-500 bg-white border border-slate-200 rounded-2xl p-8 text-center">
                Todavía no hay reseñas. ¡Sé el primero en opinar!
              </p>
            )}
            {data.reviews.slice(0, 8).map((r) => <ReviewItem key={r.id} review={r} />)}
          </div>
        </div>
      </div>
      <GoogleReviewDialog open={googleOpen} onOpenChange={setGoogleOpen} />
    </section>
  );
};
